var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ 'tw-h-full tw-w-full tw-object-cover': _vm.fill },attrs:{"decoding":"async","src":_vm.src,"srcset":_vm.localSrcset,"sizes":_vm.localSizes},on:{"click":(event) => _vm.$emit('click', event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }